import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCvv = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 11" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect
        width={13}
        height={9}
        x={0.5}
        y={0.5}
        stroke="#C2C5CC"
        rx={1}
        transform="translate(3)"
      />
      <g stroke="#4D4D4D">
        <path d="M14.178 7.503c-1.104.08-2.426.12-3.964.12-11.4 0-10.28-2.494-7.173-3.27" />
        <path d="m12.469 4.907 2.228 2.686-2.459 2.527" />
      </g>
    </g>
  </svg>
);
const Memo = memo(SvgCvv);
export default Memo;
